
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function CTASection() {
  const { t } = useTranslation('common');

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="w-full h-96 rounded-3xl overflow-hidden mb-12"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/5ab70f9e58de360b48c17e07441522d1.jpg"
            alt="CTA Background"
            className="w-full h-full object-cover object-top"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-center"
        >
          <p className="text-4xl md:text-5xl mb-2">
            <span className="text-gray-400 font-light">{t('cta.text1')}</span>
          </p>
          <p className="text-4xl md:text-5xl mb-2">
            <span className="text-gray-900 font-bold italic">{t('cta.text2')}</span>
          </p>
          <p className="text-4xl md:text-5xl mb-12">
            <span className="text-gray-900 font-bold">{t('cta.text3')}</span>
          </p>

          <button
            onClick={scrollToContact}
            className="px-12 py-5 bg-gray-900 text-white rounded-full text-lg font-medium hover:bg-gray-800 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            {t('cta.button')}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
